
import { defineComponent, onBeforeMount, PropType, reactive } from 'vue'

// components
import FileReader from '@/common/components/UI/FileReader/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { StorySlideT } from '@/core/types/stories.types'

// realisations
import { stories } from '@/core/realisations/stories.realisation'

export default defineComponent({
    components: {
        'file-reader': FileReader,
        'the-button': TheButton,
    },
    props: {
        storyId: {
            type: Number,
            default: null,
        },
        slide: {
            type: Object as PropType<StorySlideT>,
            required: true,
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    emits: ['save', 'delete'],
    setup(props, { emit }) {
        const state = reactive({
            image: null as string | null,
            images: [] as File[],
            is_saving: false,
            is_deleting: false,
        })

        onBeforeMount(() => {
            state.image = props.slide.image
        })

        const setImage = () => {
            const image_url = URL.createObjectURL(state.images[0])
            state.image = image_url
        }

        const cancel = () => {
            state.images = []
            state.image = props.slide.image
        }

        const emitSave = async () => {
            try {
                state.is_saving = true

                const payload = new FormData()
                payload.append('image', state.images[0])

                const response = await stories.updateStorySlide(props.slide.id, payload)
                emit('save', { index: props.index, image: response.data.image })

                state.image = response.data.image
                state.images = []
            } catch (error) {
                console.error(error)
            } finally {
                state.is_saving = false
            }
        }

        const emitDelete = async () => {
            const answer = confirm(`Вы действительно хотите удалить Слайд ${props.index + 1}?`)
            if (!answer) return

            try {
                state.is_deleting = true
                await stories.deleteStorySlide(props.slide.id)
                emit('delete', { index: props.index })
            } catch (error) {
                console.error(error)
            } finally {
                state.is_deleting = false
            }
        }

        return { state, cancel, setImage, emitSave, emitDelete }
    },
})
